export default __webpack_public_path__ + "static/brand-4-7c83f31e69a2bcfcf2c0b4fd9330f2a9.png";